import React, {PureComponent as Component} from 'react'; 
import {MCbrowser} from "../../Context/browserContext";
import {Link} from "react-router-dom";
import {digitsEnToFa} from "@persian-tools/persian-tools";

class  ShowProfile extends Component{

    constructor(props) {
        super(props);
        this.isAlive = true;
        this.HpicChanged = this.picChanged.bind(this);
        this.userImgRef=React.createRef();
        this.props=props;

    }

    picChanged(){
        let d1=new Date().getTime();
        this.userImgRef.current.src = "http://mdyaran.ir/membership/picture?" + d1;
    }

    componentDidMount() {
        let page = this.context.page;
        page.dispatcher.add("route", "profilePic","changed",this.HpicChanged);
    }

    render() {
        let f1=  digitsEnToFa(this.context.memberObj.following);
        let f2=  digitsEnToFa(this.context.memberObj.follower);
        return (
            <>
                <div className="box mb-3 shadow-sm border rounded bg-white profile-box text-center">
                    <div className="py-4 px-3 border-bottom">
                        <img ref={this.userImgRef} src="/images/avatar.jpg" data-src="http://mdyaran.ir/membership/picture"
                             className="lazyload blur-up img-fluid mt-2 rounded-circle mw150"/>
                        <h5 className="font-weight-bold text-dark mb-1 mt-4">
                            {this.context.memberObj.firstName}
                            &nbsp; &nbsp;
                            {this.context.memberObj.lastName}
                        </h5>
                        <p className="mb-0 text-muted">
                            {this.context.memberObj.username}
                        </p>
                    </div>
                    <div className="d-flex">
                        <div className="col-6 border-right p-3">
                            <h6 className="font-weight-bold text-dark mb-1">
                                &nbsp;  {f1} &nbsp;
                            </h6>
                            <p className="mb-0 text-black-50 small">
                                دوست
                            </p>
                        </div>
                        <div className="col-6 p-3">
                            <h6 className="font-weight-bold text-dark mb-1">
                                &nbsp;  {f2} &nbsp;
                            </h6>
                            <p className="mb-0 text-black-50 small">
                                بازدید
                                کننده
                            </p>
                        </div>
                    </div>
                    <div className="overflow-hidden border-top">
                        <Link to="/membership/profile" className="font-weight-bold p-3 d-block ">
                            نمایش پروفایل
                        </Link>
                    </div>
                </div>
            </>
        ); 
  }

    destroy() {
        if (!this.isAlive) {
            return;
        }

        this.isAlive = false;
    }

    componentWillUnmount() {
        this.destroy();
    }
}

ShowProfile.contextType = MCbrowser;

export default ShowProfile;
